/// <reference path="./global.d.ts" />
/*!
 * @preserve
 * Detect.js
 * BrowserInfoCollector Frontend JS for dein-ip-check.de (Modul: detectSystem)
 *
 * @version 3.1.6
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import { detectInternetBrowser, webglversion } from "./lib/detect.internetbrowser"
import { detectRechnerDetails, PluginObject } from "./lib/detect.rechnerdetails";
import { detectRemoteFontBlocker, localFontDetector } from "./lib/detect.fonts";
let Wiscroll = require("wiscroll");

import {murmurHash} from "./lib/murmurHash";
import ClickEvent = JQuery.ClickEvent;

const BASEURL = "/bundles/deinipcheckbrowserinfo/js/";

export default function detectSystem() {
    // Klassen instanzieren / laden
    let DetectRTC = require('detectrtc');
    
    /*
     * Rechner-Informationen abrufen
     */

    // Lokale Zeit setzen
    let localDate = $("#hasLocaleDate"), localTime = $("#hasLocaleTime");
    if(!detectRechnerDetails.startUpdateClock(localDate,localTime)) {
        localDate.html(DETECTPHRASE["Fehler beim ermitteln des Systemdatum"]);
        localTime.html("--");
    }

    // Zeitzone ermitteln
    $("#ipgeotimezone").text( detectRechnerDetails.getTimezone() );

    // Systemsprache
    detectRechnerDetails.getSystemLanguage( $("#systemLanguage") );

    // Touchscreen
    if( detectRechnerDetails.getTouchscreenStatus() ) {
        $("#systemTouchscreen").text( DETECTPHRASE["vorhanden"] );
    } else {
        $("#systemTouchscreen").text( DETECTPHRASE["nicht vorhanden"] );
    }

    // Display-Orientierung
    $("#hasOrientierung").text( detectRechnerDetails.updateOrientation() );
    window.addEventListener("orientationchange", function() {
        $("#hasOrientierung").text( detectRechnerDetails.updateOrientation() );
    }, false);

    // Display-Gräße
    $("#hasScreenSize").text( detectRechnerDetails.getScreenSize() );

    // Fenstergröße ermitteln
    $("#hasWindowSize").html( detectRechnerDetails.getWindowSize() );
    window.addEventListener("resize", function() {
        $("#hasWindowSize").html( detectRechnerDetails.getWindowSize() );
    }, false);

    // Flash Status ermitteln
    detectRechnerDetails.getFlashStatus(
        BASEURL + 'FlashDetector.swf',
        function() {
            $("#hasFlash").html(DETECTPHRASE["vorhanden"]).removeClass("label-info").addClass("label-success");
        },
        function() {
            $("#hasFlash").html(DETECTPHRASE["nicht vorhanden"]).removeClass("label-info").addClass("label-danger");
        }
    );

    // Java Status ermitteln
    detectRechnerDetails.getJavaStatus(
        function() {
            $("#hasJava").html(DETECTPHRASE["vorhanden"]).removeClass("label-info").addClass("label-success");
        },
        function() {
            $("#hasJava").html(DETECTPHRASE["nicht vorhanden"]).removeClass("label-info").addClass("label-danger");
        }
    );

    /*
     * Browser-Informationen abrufen
     */

    // Prüfe auf falsche Informationen
    if(forceJSBasedSystemDetection === '1') {
        console.info('Starte erweiterte System-Prüfung für Tablet-Erkennung unter iOS-Geräte');
        if(navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
            $('#systemNameIcon').removeClass('fa-desktop').addClass('fa-tablet');
            $('#systemName').text('Tablet');
            $('#platformName').text('iPadOS ' + $('#browserName').text().replace( /[^\d\.]*/g, ''));
        }
    }
    
    // Javascript-Version
    $("#javascriptversion").html( ` / Version ${detectInternetBrowser.getJavascriptVersion().toString()}` );

    // ActiveX vorhanden
    if(detectInternetBrowser.getActiveXSupport()) {
        $("#hasActiveX").html(DETECTPHRASE["vorhanden"]).removeClass( "label-info" ).addClass( "label-success" );
    } else {
        $("#hasActiveX").html(DETECTPHRASE["nicht vorhanden"]).removeClass( "label-info" ).addClass( "label-danger" );
    }

    // Anzahl der URLs in der History
    if(detectInternetBrowser.getHistory() === 1) {
        $("#historyDetails").html( `${DETECTPHRASE['Es ist']} ${detectInternetBrowser.getHistory()} ${DETECTPHRASE["URL"]} ${DETECTPHRASE["in der History"]}` );
    } else {
        $("#historyDetails").html( `${DETECTPHRASE['Es sind']} ${detectInternetBrowser.getHistory()} ${DETECTPHRASE["URL"]}s ${DETECTPHRASE["in der History"]}` );
    }

    // Storages prüfen
    if (detectInternetBrowser.getIndexDBStatus() === true) {
        $("#hasIndexDB").html(
            `IndexDB<span class="hidden-xxs"> ${DETECTPHRASE["vorhanden"]}</span>`).removeClass("label-info").addClass("label-success"
        );
    } else {
        $("#hasIndexDB").html(
            `IndexDB<span class="hidden-xxs"> ${DETECTPHRASE["nicht vorhanden"]}</span>`).removeClass("label-info").addClass("label-danger"
        );
    } 
    if (detectInternetBrowser.getLocalStorageStatus() === true) {
        $("#hasLocalStorage").html(
            `Local Storage<span class="hidden-xxs"> ${DETECTPHRASE["vorhanden"]}</span>`).removeClass("label-info").addClass("label-success"
        );
    } else {
        $("#hasLocalStorage").html( 
            `Local Storage<span class="hidden-xxs"> ${DETECTPHRASE["nicht vorhanden"]}</span>`).removeClass("label-info").addClass("label-danger"
        );
    }
    if (detectInternetBrowser.getSessionStorageStatus() === true) {
        $("#hasSessionStorage").html(
            `Session Storage<span class="hidden-xxs"> ${DETECTPHRASE["vorhanden"]}</span>`).removeClass("label-info").addClass("label-success"
        );
    } else {
        $("#hasSessionStorage").html(
            `Session Storage<span class="hidden-xxs"> ${DETECTPHRASE["nicht vorhanden"]}</span>`).removeClass("label-info").addClass("label-danger"
        );
    }

    // WebFonts-Protection
    detectRemoteFontBlocker.fontBlocked(
        "Raleway",
        function() {
            $("#cssFontProtection").html(`${DETECTPHRASE["Filter"]}: ${DETECTPHRASE["inaktiv"]}`)
                .removeClass("label-info").addClass("label-danger");
        },
        function() {
            $("#cssFontProtection").html(`${DETECTPHRASE["Filter"]}: ${DETECTPHRASE["aktiv"]}`)
                .removeClass("label-info").addClass("label-success");
        }
    );

    // Cookie Status ermitteln
    if(navigator.cookieEnabled) {
        $("#hasCookie").html(DETECTPHRASE["vorhanden"]).removeClass( "label-info" ).addClass( "label-success" );
    } else {
        $("#hasCookie").html(DETECTPHRASE["nicht vorhanden"]).removeClass( "label-info" ).addClass( "label-danger" );
    }

    // Auf 3.Party Cookies Support prüfen
    detectInternetBrowser.start3PartyCookieTest("#has3rdPartyCookie",
        function(cookieSuccess: boolean) {
            if(cookieSuccess) {
                $("#has3rdPartyCookie").html(
                    `${DETECTPHRASE["Schutz"]} ${DETECTPHRASE["inaktiv"]}`)
                    .removeClass( "label-info" )
                    .addClass( "label-danger"
                    );
            } else {
                $(
                    "#has3rdPartyCookie").html(`${DETECTPHRASE["Schutz"]} ${DETECTPHRASE["aktiv"]}`)
                    .removeClass( "label-info" )
                    .addClass( "label-success"
                    );
            }
        },
        function() {
            $("#has3rdPartyCookie").html(
                "---")
                .removeClass("label-info")
                .addClass("label-warning");
        }
    );

    /**
     * WebRTC-Stuff
     */

    let localIP:string[] = [],
        rtcTestStatus:boolean = false;
    
    // noinspection TypeScriptValidateJSTypes
    DetectRTC.load(function() {
        if (DetectRTC.isWebRTCSupported) {
            // WebRTC Support vorhanden - prüfe nach Audio-Einschränkungen
            let prefix = "";
            if (DetectRTC.hasSpeakers === false && (DetectRTC.browser.name === 'Chrome' || DetectRTC.browser.name === 'Edge')) {
                // noinspection JSNonASCIINames
                prefix = ` (${DETECTPHRASE["ohne Audio-Unterstützung"]})`;
            }
            $("#hasWebRTC").html(DETECTPHRASE["vorhanden"] + prefix)
                .removeClass("label-info")
                .addClass("label-success");

            let btnLocalIPTest = $("#refreshLocalIP");
            btnLocalIPTest.removeAttr("disabled");

            // Geräte ermitteln
            if(DetectRTC.hasSpeakers) {
                $("#hasSpeaker").html(`${DETECTPHRASE["Lautsprecher"]}: ${DETECTPHRASE["vorhanden"]}`)
                    .removeClass("label-info").addClass("label-success");
            } else {
                // Lautsprecher-Prüfung steht aktuell nur in Google Chrome zur Verfügung
                if (DetectRTC.browser.name === "Chrome") {
                    $("#hasSpeaker").html(`${DETECTPHRASE["Lautsprecher"]}: ${DETECTPHRASE["nicht vorhanden"]}`)
                        .removeClass("label-info").addClass("label-danger");
                } else {
                    let speakerElement = $("#hasSpeaker");
                    speakerElement.html(`${DETECTPHRASE["Lautsprecher"]}: ${DETECTPHRASE["unbekannt"]}`)
                        .hide();
                    speakerElement.next().hide();
                }
            }
            if(DetectRTC.hasMicrophone) {
                $("#hasMicrophone").html(`${DETECTPHRASE["Mikrofon"]}: ${DETECTPHRASE["vorhanden"]}`)
                    .removeClass("label-info").addClass("label-success");
            } else {
                $("#hasMicrophone").html(`${DETECTPHRASE["Mikrofon"]}: ${DETECTPHRASE["nicht vorhanden"]}`)
                    .removeClass("label-info").addClass("label-danger");
            }
            if(DetectRTC.hasWebcam) {
                $("#hasWebcam").html(`${DETECTPHRASE["Webcam"]}: ${DETECTPHRASE["vorhanden"]}`)
                    .removeClass("label-info").addClass("label-success");
            } else {
                $("#hasWebcam").html(`${DETECTPHRASE["Webcam"]}: ${DETECTPHRASE["nicht vorhanden"]}`)
                    .removeClass("label-info").addClass("label-danger");
            }

            // Button für Erkennung lokaler IP freigeben
            btnLocalIPTest.on("click", function(event:ClickEvent) {
                event.preventDefault();

                // Prüfe ob Button freigegeben ist
                if (!btnLocalIPTest.attr("disabled")) {
                    // noinspection JSUnusedLocalSymbols
                    DetectRTC.DetectLocalIPAddress(function(rtcIpAddress:string, rtcIsPublic:boolean, rtcIsIPv4:boolean) {
                        if(rtcIpAddress !== undefined) {
                            let ipAdress = rtcIpAddress.replace("Local: ", "").replace("Public: ", "");
                            if (/(^127\.)|(^192\.168\.)|(^10\.)|(^172\.1[6-9]\.)|(^172\.2[0-9]\.)|(^172\.3[0-1]\.)|(^::1$)|(^[fF][cCdD])\r\n/i.test(ipAdress)) {
                                // Test abgeschlossen
                                rtcTestStatus = true;
    
                                // IP-Adresse in Liste hinzufügen
                                localIP.push(
                                    ipAdress
                                ); //+ ' (Privat IPv4)');
    
                                $("#localIP").html( localIP.join(", ") );
                            } /* else {
                                // Test abgeschlossen
                                rtcTestStatus = true;
                                
                                // IP-Adresse in Liste hinzufügen
                                localIP.push(
                                    ipAddress.replace("Public: ", "") + 
                                    ' (Öffentlich ' + (isIPv4 ? 'IPv4' : 'IPv6') + ')'
                                );
                                $("#localIP").html( localIP.join(", ") );
                            } */
                        }
                    });

                    // Prüfe ob Check erfolgreich war
                    setTimeout(function() {
                        if(rtcTestStatus === false) {
                            $("#refreshLocalIP").attr("disabled","disabled");
                            // noinspection JSNonASCIINames
                            bootbox.alert({
                                title: DETECTPHRASE["Ermittlung der lokalen IPv4-Adresse fehlgeschlagen"] + ":",
                                message: `<p>${DETECTPHRASE["Ihre lokale IPv4-Adresse konnte nicht über Ihren Internetbrowser ermittelt werden"]}</p>`,
                                backdrop: true
                            });
                        }
                    }, 1000);
                }
            });
        } else {
            // Kein WebRTC Support vorhanden
            $("#hasWebRTC").html(DETECTPHRASE["nicht vorhanden"])
                .removeClass("label-info")
                .addClass("label-danger");
            $("#hasSpeaker").html(`${DETECTPHRASE["Lautsprecher"]}: ${DETECTPHRASE["nicht ermittelbar"]}`)
                .removeClass("label-info")
                .addClass("label-warning");
            $("#hasMicrophone").html(`${DETECTPHRASE["Mikrofon"]}: ${DETECTPHRASE["nicht ermittelbar"]}`)
                .removeClass("label-info")
                .addClass("label-warning");
            $("#hasWebcam").html(`${DETECTPHRASE["Webcam"]}: ${DETECTPHRASE["nicht ermittelbar"]}`)
                .removeClass("label-info")
                .addClass("label-warning");
            // noinspection JSNonASCIINames
            $("#refreshLocalIP").tooltip({title: DETECTPHRASE["Erkennung nur bei WebRTC Unterstützung verfügbar"]});
        }
    });

    /**
     * Fingerprinting-Code
     */
    if(!detectInternetBrowser.getCanvasStatus()) {
        // Canvas-Support ist generell blockiert
        // noinspection JSNonASCIINames
        $("#canvasProtection").html(DETECTPHRASE["Canvas wird nicht unterstützt"]).addClass("label").addClass("label-info");
    } else {
        // Canvas steht zur Verfügung
        const canvasFingerprintImage = detectInternetBrowser.getCanvasFingerprintSampleImage();
        if(canvasFingerprintImage !== null) {
            // Fingerprint berechnen
            let canvasFingerprint = murmurHash.x64hash128(canvasFingerprintImage, 31);

            // Fingerprint ausgeben
            $("#hasCanvasFingerprintButton").show();
            $("#canvasProtection").text(canvasFingerprint);
            $("#canvasFingerprint").text(canvasFingerprint);
            $("#canvasFingerprintImage").html(`<img src='${canvasFingerprintImage}' title='Fingerprint' alt='Fingerprint' />`);
        } else {
            // Canvas Fingerprint-Image wurde nicht erzeugt
            // noinspection JSNonASCIINames
            $("#canvasProtection").html(DETECTPHRASE["Canvas wird nicht unterstützt"]).addClass("label").addClass("label-info");
        }
    }

    /**
     * WebGL-Code
     */
    if(!detectInternetBrowser.getWebGLStatus()) {
        // WebGL Unterstützung fehlt
        // noinspection JSNonASCIINames
        $("#hasWebGL").html(DETECTPHRASE["keine Unterstützung"]).removeClass("label-info").addClass("label-danger");
        $("#WebGLVendor").html(DETECTPHRASE["nicht ermittelbar"]);
        // noinspection JSNonASCIINames
        $("#webglProtection").html(DETECTPHRASE["WebGL wird nicht unterstützt"]).addClass("label").addClass("label-info");
    } else {
        // WebGL Unterstützung vorhanden
        // Vendor / Version und WebGL-Details auslesen
        const webGLvendor = detectInternetBrowser.getWebGLVendor();
        const webGLversion:webglversion = detectInternetBrowser.getWebGLVersion();

        // Vendor ausgeben
        if(webGLvendor !== null) {
            $("#WebGLVendor").html(webGLvendor);
        } else {
            $("#WebGLVendor").html("nicht ermittelbar");
        }

        // WebGL Version ausgeben
        let strWebGLVersion:string;
        if(webGLversion !== null) {
            strWebGLVersion = `${DETECTPHRASE["aktiv"]} / ${webGLversion.major}`
        } else {
            strWebGLVersion = DETECTPHRASE["aktiv"];
        }
        $("#hasWebGL").html(strWebGLVersion)
            .removeClass("label-info").addClass("label-success");

        // WebGL-Details ausgeben (Popup)
        let webGLDetails = detectInternetBrowser.getWebGLDetails(),
            htmlWebGLPopup: JQuery.htmlString;

        if(webGLversion !== null) {
            if(webGLversion.minor !== null) {
                htmlWebGLPopup = `<p><strong>${webGLversion.major}</strong><br />(${webGLversion.minor})</p>`;
            } else {
                htmlWebGLPopup = `<p><strong>${webGLversion.major}</strong></p>`;
            }
        } else {
            htmlWebGLPopup = "<p><strong>Keine WebGL-Versionsangabe verfügbar</strong></p>";
        }
        if(webGLDetails !== null) {
            htmlWebGLPopup = `${htmlWebGLPopup}<p><strong>WebGL-Details:</strong></p><p style='text-align: left'>${webGLDetails.join("<br />")}</p>`;
        } else {
            htmlWebGLPopup = `${htmlWebGLPopup}<p><strong>WebGL-Details:</strong></p><p style='text-align: left'>Keine WebGL-Details verfügbar</p>`;
        }
        $("#hasWebGLVersionButton").show();
        $("#hasWebGLFullVersion").html( htmlWebGLPopup );

        // Fingerprint erzeugen
        let webglFingerprintImage = detectInternetBrowser.getWebGLprintSampleImage();
        if (webglFingerprintImage == null) {
            // Fingerprint-Grafik wurde nicht erfolgreich erzeugt
            // noinspection JSNonASCIINames
            $("#webglProtection").html(DETECTPHRASE["WebGL wird nicht unterstützt"]);
            // noinspection JSNonASCIINames
            $("#webglFingerprint").text(DETECTPHRASE["WebGL wird nicht unterstützt"]);
        } else {
            // Fingerprint-Grafik auswerten
            $("#hasWebGLFingerprintButton").show();
            let webglFingerprintHash = murmurHash.x64hash128(webglFingerprintImage, 31);

            $("#webglProtection").html(webglFingerprintHash);
            $("#webglFingerprint").text(webglFingerprintHash);
            $("#webglFingerprintImage").html(
                `<img src='${webglFingerprintImage}' title='Fingerprint' alt='fingerprint'/>`
            );
        }
    }

    /*
     * Windows 11 Status ermitteln
     */
    if(forceBrowserInfoUpdate === '1') {
        console.info("Aktualisiere Betriebssystem-Information");

        $.post(AJAXENDPOINT + "/browserhints", null, function (response) {
            // Ergebnis erhalten
            if (typeof response.result !== "undefined") {
                if(response.result.Status >= 0) {
                    if(!!response.result.Platform_Name) {
                        $("#platformName").text(`${response.result.Platform_Name} ${response.result.Platform_Version}`)
                    }
                    if(!!response.result.Browser_Name) {
                        $("#browserName").text(`${response.result.Browser_Name} ${response.result.Browser_Version}`)
                    }
                    if(!!response.result.Platform_Model) {
                        $("#systemName").append(` (${response.result.Platform_Model})`);
                    }
                    if(!!response.result.System_Architecture) {
                        $("#systemArchitecture").text(`${response.result.System_Architecture}`);
                    } else {
                        // Systemarchitektur auf herkömmlichen Weg ermitteln
                        $("#systemArchitecture").text( detectRechnerDetails.getSystemArchitecture() );
                    }
                } else {
                    // Keine erweiterten Rechnungsinformationen verfügbar
                    console.info("Erweiterte Browser-Informationen nicht verüfgbar")

                    // CPU-Architektur über Browserkennung ermitteln
                    $("#systemArchitecture").text( detectRechnerDetails.getSystemArchitecture() );
                }
            } else {
                // Rückgabe der Browser-/Rechner-Daten ist ungültig
                console.warn("Rückgabe der BrowserDetails nicht gültig");

                // CPU-Architektur über Browserkennung ermitteln
                $("#systemArchitecture").text( detectRechnerDetails.getSystemArchitecture() );
            }
        }).fail(function (jqXhr, textStatus, errorThrown) {
            // CPU-Architektur über Browserkennung ermitteln
            $("#systemArchitecture").text( detectRechnerDetails.getSystemArchitecture() );

            // Warnung ausgeben bei Fehler
            console.warn("Fehler beim ermitteln der Windows-Version: " + textStatus);
            console.warn(errorThrown);
        });
    } else {
        console.info("Kein Update der Betriebssystem-Information notwendig");

        // CPU-Architektur über Browserkennung ermitteln
        if(forceSystemArchitectureUpdate === '1') {
            $("#systemArchitecture").text(detectRechnerDetails.getSystemArchitecture());
        }
    }
    
    
    /**
     * Ad-Blocker und Co ermitteln
     */

    // Adcheck Regeln
    const AdRules = [
            { domID: "ad-img", domClass: "", domSrc: "", domElement: "div", type: 2},
            { domID: "", domClass: "gtadlb", domSrc: "", domElement: "div", type: 1},
            { domID: "adbuddy-no-adb-container", domClass: "", domSrc: "", domElement: "div", type: 2},
            { domID: "ad-block-enabled", domClass: "", domSrc: "", domElement: "div", type: 2},
            { domID: "like-us-adblock-modal", domClass: "", domSrc: "", domElement: "div", type: 2},
            { domID: "", domClass: "", domSrc: "/1x1.gif?" + Math.floor(Math.random() * 1000), domElement: "img", type: 3}
        ];

    // Container anlegen (außerhalb des sichtbaren Views) für die Test-DOM-Elemente
    const adTestContainer = $("<div id='adBlockTest' />")
        .css("position", "absolute")
        .css("left", "-3456px")
        .appendTo("#main");

    // Lege DOM elemente zur Prüfung an
    interface adElementObject {
        dom: JQuery<HTMLElement>,
        type: number
    }

    let adElement:adElementObject[] = [];
    AdRules.forEach(
        function (rule) {
            let elementCode = $("<" + rule.domElement + " " +
                (rule.domID ? "id='" + rule.domID + "' " : "") +
                (rule.domClass ? "class='" + rule.domClass + "' " : "") +
                (rule.domSrc ? "src='" + rule.domSrc + "' " : "") +
                ">Test</" + rule.domElement + ">"
            );

            adElement.push(
                { dom: elementCode.appendTo(adTestContainer), type: rule.type}
            );
        }
    );

    // Prüfe ob DOM Elemente ausgeblendet sind
    setTimeout(function() {
        let hasAdFilter = false,
            hasAdblockWarnerFilter = false,
            hasPrivacyFilter = false;

        adElement.forEach(
            function (adRule) {
                if ( adRule.dom.css('display') == 'none' || adRule.dom.css("visibility") == "hidden"){
                    if(adRule.type == 1) hasAdFilter = true;
                    if(adRule.type == 2) hasAdblockWarnerFilter = true;
                    if(adRule.type == 3) hasPrivacyFilter = true;
                }
            }
        );

        // Gezielt nochmal nach Google Ads prüfen
        let adsbygoogle = $(".adsbygoogle");
        if(!adsbygoogle[0].hasChildNodes() || adsbygoogle.height() === 0) {
            //console.info("Keine Google Ads :-(");
            hasAdFilter=true;
        }
        
        // Adfilter-Test auswerten
        if(hasAdFilter) {
            $("#hasAdFilter")
                .removeClass("label-info").addClass("label-success")
                .html(`${DETECTPHRASE["Filter"]}: ${DETECTPHRASE["aktiv"]}`);
            
            /*
            if($('html').attr('lang') == "en") {
                $(".adsbygoogle:first").replaceWith(
                    "<div class=\"alert alert-danger\" role=\"alert\" style=\"font-size: 1.25em\">" +
                    "<b><i class=\"fas fa-frown text-center\"></i> Important notice in own regard!</b><br />" +
                    "You're using an adblocker. This site is 100% funded by advertising. Support us by deactivating your Adblocker." +
                    "</div>"
                );
            } else {
                $(".adsbygoogle:first").replaceWith(
                    "<div class=\"alert alert-danger\" role=\"alert\" style=\"font-size: 1.25em\">" +
                    "<b><i class=\"fas fa-frown text-center\"></i> Wichtiger Hinweis in eigener Sache!</b><br />" +
                    "Sie verwenden einen Adblocker. Diese Seite finanziert sich zu 100% durch Werbung. Unterstützen Sie uns, indem Sie Ihren Adblocker deaktivieren." +
                    "</div>"
                );
            }          
            */
        } else {
            $("#hasAdFilter").addClass("label-danger").html(`${DETECTPHRASE["Filter"]}: ${DETECTPHRASE["inaktiv"]}`);
        }
        if(hasAdblockWarnerFilter) {
            $("#hasAdblockWarnerFilter")
                .removeClass("label-info").addClass("label-success")
                .html(`${DETECTPHRASE["Filter"]}: ${DETECTPHRASE["aktiv"]}`)
        } else {
            $("#hasAdblockWarnerFilter")
                .removeClass("label-info").addClass("label-danger")
                .html(`Filter: ${DETECTPHRASE["inaktiv"]}`);
        }
        if(hasPrivacyFilter) {
            $("#hasPrivacyFilter")
                .removeClass("label-info").addClass("label-success")
                .html(`${DETECTPHRASE["Filter"]}: ${DETECTPHRASE["aktiv"]}`)
        } else {
            $("#hasPrivacyFilter")
                .removeClass("label-info").addClass("label-danger")
                .html(`Filter: ${DETECTPHRASE["inaktiv"]}`)
        }

        adTestContainer.remove();
    }, 3000);

    /**
     * Listen ausfüllen
     */

    // Dropdown-Listen füllen sobald dargestellt
    require('intersection-observer');
    let localFonts = new localFontDetector();
    let fontElement = document.querySelector('#fontListHeader');
    // noinspection JSUnusedLocalSymbols
    let test = new Wiscroll(fontElement).on(
        '95% top',
        function(entry: any) {
            // Fensterlemente
            const windowElements = detectInternetBrowser.getWindowElements();
            if(windowElements.length > 0) {
                $("#windowElementsHeader").append( `<span class="badge">${windowElements.length}</span>` );
                $("#hasWindowElements").html("");
                windowElements.forEach(function (element: string) {
                    $("#hasWindowElements").append(`<li class="list-group-item">${DETECTPHRASE[element]}</li>`);
                });
            } else {
                $("#hasWindowElements").html(`<li class="list-group-item">${DETECTPHRASE["Aktive Fensterelemente konnten nicht bestimmt werden"]}</li>`)
            } 

            // Plugins
            if (detectInternetBrowser.isIE()) {
                interface pluginDefinition {
                    name: string,
                    description: string,
                }
                
                if ((Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(window, 'ActiveXObject')) || ('ActiveXObject' in window)) {
                    const pluginNames: pluginDefinition[] = [
                        {name: 'AcroPDF.PDF', description: 'Adobe PDF reader 7+' },
                        {name: 'Adodb.Stream', description: 'Microsoft ADO Stream Object' },
                        {name: 'AgControl.AgControl', description: 'Microsoft Silverlight' },
                        {name: 'DevalVRXCtrl.DevalVRXCtrl.1', description: 'DevalVR Viewer' },
                        {name: 'MacromediaFlashPaper.MacromediaFlashPaper', description: 'Macromedia FlashPaper' },
                        {name: 'Msxml2.DOMDocument', description: 'Microsoft MSXML2 - DOMDocument' },
                        {name: 'Msxml2.XMLHTTP', description: 'Microsoft MSXML2 - XMLHTTP' },
                        {name: 'PDF.PdfCtrl', description: 'Adobe PDF Reader <6' },
                        {name: 'QuickTime.QuickTime', description: 'Apple QuickTime' },
                        {name: 'QuickTimeCheckObject.QuickTimeCheck.1', description: 'Apple QuickTime Check' },
                        {name: 'RealPlayer', description: 'Real Player' },
                        {name: 'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)', description: 'Real Player ActiveX 32-Bit' },
                        {name: 'RealVideo.RealVideo(tm) ActiveX Control (32-bit)', description: 'Real Video ActiveX 32-Bit' },
                        {name: 'rmocx.RealPlayer G2 Control', description: 'RealPlayer G2' },
                        {name: 'rmocx.RealPlayer G2 Control.1', description: 'RealPlayer G2 1' },
                        {name: 'Scripting.Dictionary', description: 'Microsoft Scripting Dictionary' },
                        {name: 'SWCtl.SWCtl', description: 'Adobe ShockWave Player' },
                        {name: 'Shell.UIHelper', description: 'Microsoft Shell UIHelper' },
                        {name: 'ShockwaveFlash.ShockwaveFlash', description: 'Adobe ShockWave Flash Player' },
                        {name: 'Skype.Detection', description: 'Microsoft Skype' },
                        {name: 'TDCCtl.TDCCtl', description: 'VideoLAN Plugin' },
                        {name: 'WMPlayer.OCX', description: 'Windows Mediaplayer' },
                    ]
                    let pluginList:pluginDefinition[] = [];
                    pluginNames.forEach(function(plugin){
                        try {
                            new window.ActiveXObject(plugin.name);
                            pluginList.push(plugin);
                        } catch (e) { } 
                    });
                    if(pluginList.length > 0) {
                        $("#pluginListHeader").append( `<span class="badge">${pluginList.length}</span>` );
                        $("#hasPluginList").html("");
                        pluginList.forEach(function(element: pluginDefinition) {
                            $("#hasPluginList").append( '<li class="list-group-item">' + element.description + '<br /><i>(' + element.name + ')</i></li>');
                        });
                    } else {
                        $("#hasPluginList").html(`<li class="list-group-item">${DETECTPHRASE["Es konnten keine Plugins ermittelt werden"]}</li>`)
                    }
                } else {
                    $("#hasPluginList").html(`<li class="list-group-item">${DETECTPHRASE["Es konnten keine Plugins ermittelt werden"]}</li>`)
                }
            } else { 
                // 
                // PLugin-Liste für Nicht-IE Browser
                //
                const pluginList = detectRechnerDetails.getPluginList();
                if(pluginList !== null && pluginList.length > 0) {
                    $("#pluginListHeader").append( `<span class="badge">${pluginList.length}</span>` );
                    $("#hasPluginList").html("");
                    pluginList.forEach(function(element: PluginObject) {
                        $("#hasPluginList").append( '<li class="list-group-item">' +
                            element.pluginName +
                            (element.pluginDetails.length > 0 ? "<br />" + element.pluginDetails : "") +
                            '</li>'
                        );
                    });
                } else {
                    $("#hasPluginList").html(`<li class="list-group-item">${DETECTPHRASE["Es konnten keine Plugins ermittelt werden"]}</li>`)
                }
            }
            
            // Lokale Fonts ermitteln
            localFonts.startSearch(
                BASEURL + "FontList.swf",
                BASEURL + "detect.font.worker.js",
                function() {
                    $("#fontListHeader").append(`<span id="FontInfoBadge" class="badge">${DETECTPHRASE["Erkennung via Flash"]}</span>`);
                },
                function() {
                    $("#fontListHeader").append(`<span id="FontInfoBadge" class="badge">${DETECTPHRASE["Erkennung via JS"]}</span>`);
                }
            );            
            test.cancel();
        },
        function(targetBIsHigher: boolean, entry: any) {
            if (!targetBIsHigher) {
                console.info('Init: Font-Zone bereits beim laden erreicht');
                localFonts.startSearch(
                    BASEURL + "FontList.swf",
                    BASEURL + "detect.font.worker.js",
                    function() {
                        $("#fontListHeader").append(`<span id="FontInfoBadge" class="badge">${DETECTPHRASE["Erkennung via Flash"]}</span>`);
                    },
                    function() {
                        $("#fontListHeader").append(`<span id="FontInfoBadge" class="badge">${DETECTPHRASE["Erkennung via JS"]}</span>`);
                    }
                );
            }
        }
    );
    
    /*
    let localFonts = new localFontDetector();
    localFonts.startSearch(
        BASEURL + "FontList.swf",
        BASEURL + "detect.font.worker.js",
        function() {
            $("#fontListHeader").append(`<span id="FontInfoBadge" class="badge">${DETECTPHRASE["Erkennung via Flash"]}</span>`);
        },
        function() {
            $("#fontListHeader").append(`<span id="FontInfoBadge" class="badge">${DETECTPHRASE["Erkennung via JS"]}</span>`);
        }
    );
     */
};
